import Reveal from "@/components/Reveal";
import { STORE } from "@/data/store";

const SECTIONS = [
  { title: "1. Who We Are", body: `This website is operated by ${STORE.name}, a family-run kirana and general store located at ${STORE.address}. You can reach us at ${STORE.email} or ${STORE.phoneDisplay} for any privacy-related question.` },
  { title: "2. Information We Collect", body: "We collect only what you voluntarily share with us: your name, phone number, email address, query type and message when you submit the contact form, call us, or message us on WhatsApp. We do not run account registrations, and we do not collect payment card details on this website." },
  { title: "3. How We Use Your Information", body: "Your details are used solely to respond to your enquiry, prepare and deliver your orders, and — if you are a regular customer — maintain your khata (credit ledger) accurately. We do not sell, rent or trade your personal information to any third party." },
  { title: "4. Contact Form Submissions", body: "Messages sent through our contact form are stored securely so we can follow up with you. Each submission is retained only as long as needed to resolve your request, after which it may be deleted or anonymised." },
  { title: "5. Local Order & Delivery Data", body: "For home deliveries we note your address and contact number. This information stays within the store's records, is accessible only to family members running the shop, and is never shared with advertisers or data brokers." },
  { title: "6. Cookies & Analytics", body: "This website may use basic, privacy-respecting analytics to understand which pages are visited. No advertising trackers are installed, and no cross-site profiling takes place." },
  { title: "7. Third-Party Links", body: "Links to WhatsApp, Google Maps and email clients are provided for convenience. When you use them, their own privacy policies apply, and we encourage you to review those policies." },
  { title: "8. Your Rights", body: `You may ask us at any time to view, correct or delete the personal details we hold about you. Simply email ${STORE.email} or call ${STORE.phoneDisplay} and we will act on your request promptly.` },
  { title: "9. Changes to This Policy", body: "If we update this policy, the revised version will be posted on this page with a fresh date. Continued use of the website after changes means you accept the updated policy." },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="pt-32 lg:pt-40 pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-8">
        <Reveal>
          <p className="font-code text-xs uppercase tracking-[0.25em] text-terra mb-4">Legal</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.1]" data-testid="privacy-title">
            Privacy Policy
          </h1>
          <p className="font-code text-xs tracking-wider text-muted-foreground mt-5">
            Last updated: July 2026 · {STORE.name}
          </p>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mt-6">
            Your trust is the foundation of our shop — in the bazaar and online. This policy
            explains, in plain words, what we collect and why.
          </p>
        </Reveal>

        <div className="mt-14 space-y-10" data-testid="privacy-sections">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={Math.min(i * 0.04, 0.3)}>
              <section className="border-b border-border pb-10">
                <h2 className="font-display text-xl sm:text-2xl font-medium leading-snug">{s.title}</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mt-3">{s.body}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
